/**
 * Newsroom Page Module
 * 
 * @description
 * <p>Handles Newsroom page filter menus and overlays</p>
 * <p>On page load, sets up click functions for .newsroom-btn objects</p>
 * <p>Self-initializes when you include this module.</p>
 * 
 * @module page-newsroom
 *
 * @namespace site.newsroom
 *
 */
;( /* @lends module:page-newsroom */ function(site,$){
	"use strict";

	var trace = {push: function() {}},
		dom = {},
		data = [],
		next = 0,
		current = 0,
		page = 0,
		has_newsrooms = true,
		year = '',
		month = '',
		news_type = 'All',
		brand = 'All',
		keyword='',
		brand_peacock = 'All',
		multi_brand = false;

	function init() {

		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};

		dom.active = $('.newsroom-active'); 

		dom.newsBtn = $('.newsroom-btn');
		dom.newsBtn.first = $('.newsroom-btn:first');

		dom.nav = $('.newsroom-nav');
		dom.navHolder = $('.newsroom-nav-holder');
		dom.navContent = $('.newsroom-nav-content');
		dom.drawer = $('.newsroom-nav-drawer');
		dom.navMenu = $('.newsroom-nav-menu');
		dom.navMenu.on('click', function(){
			openMenu();
		});

		dom.footer = $('footer');

		/// loop through timeline nav btns and a click event for scrolling to the decade, along with identifying the progress circle
		dom.newsBtn.each(function(index){
			data.push({'obj':$(this)});			
		});
		if ( dom.newsBtn.length != 10 ) {
			has_newsrooms = false;
		} 
		$(window).on("load", function() {
			$(function(){
				var newsroom_path_type = location.pathname.split("/");
				if ( newsroom_path_type.length > 2 ){
					if(newsroom_path_type[2] == "press-releases"){
						news_type = 'press_release';
						$(".path-newsroom-press-releases .news-type #news_opt_list li#news_opt_list_2").trigger("click");
					}				
					if(newsroom_path_type[2] == "articles-blogs"){
						news_type = 'article';
						$(".path-newsroom-articles-blogs .news-type #news_opt_list li#news_opt_list_1").trigger("click");
					}				
					if(newsroom_path_type[2] == "peacock"){
						brand_peacock = 79;
						$(".path-newsroom-peacock .news-type #news_opt_list li#news_opt_list_3").trigger("click");
					}
				}
				if ( newsroom_path_type.length > 3 ) {
					var brand_path_name = newsroom_path_type[3];
					var brand_input_name = brand_path_name.replace(/%20/g, " ");
					$(".brand #brand_opt_list li").each(function(el){
						var brand_text_val = $(this).attr('data-brand-name');
						if(brand_text_val == brand_input_name) {
							$(this).trigger("click");
							return false;
						}
					});
				}

			});
		});
		$('.newsroom #search_input').on('keypress', function(e) {
			if (!e) e = window.event;
			var keyCode = e.keyCode || e.which;
			if (keyCode == '13'){
				var new_keyword = $(this).val();
				if (new_keyword.trim() != keyword) {
					page = 0;
					keyword = new_keyword;
					getNewsroomFeed();
				}
			}
		});
		$('.newsroom #search_arrow').on('click', function() {
			var new_keyword = $('.newsroom #search_input').val();
			if (new_keyword.trim() != keyword) {
				page = 0;
				keyword = new_keyword;
				getNewsroomFeed();
			}
		});
		$('.newsroom #search_input').on('change keyup copy paste cut', function() {
			var new_keyword = $('.newsroom #search_input').val();
			if (new_keyword.trim() == "") {
				keyword='';
				getNewsroomFeed();
			}
		});
		$(document).on('click', '.newsroom-btn', function(){
			$('.newsroom-btn').removeClass('active');
			$(this).addClass('active');
			set($(this).find('.nid').val());
		});
		dom.navContent.on('scroll',function() {
			var $elem=$(this);
			var newScrollLeft = $elem.scrollLeft(),
				width=$elem.width(),
				scrollWidth=$elem.get(0).scrollWidth;
			if(has_newsrooms && ((site.getBreakPoint() == 'bp-large') && ($elem.scrollTop() + $elem.height() == $elem[0].scrollHeight) || ((scrollWidth- newScrollLeft-width)<1 && site.getBreakPoint() != 'bp-large'))) {
			   if (site.getBreakPoint() == 'bp-large') {
				   $elem.addClass('overlay');
				   $elem.find('.ajax-read-more').show();
			   }
			   page++;
			   getNewsroomFeed();
		   }
		});
		trace.push(data.length);
		if(data.length == 0) return;
		dom.newsBtn.first.addClass('active');
		loadFirstNewsroom(dom.newsBtn.first.find('.nid').val());
		scrolling();

		$(document).on('click', '.brand .multi_brand .custom-select-clear', function(){
			brand = 'All';
			multi_brand = false;
			var brandSelectArr = "";
			$(".brand #brand_opt_list .location-checkbox.checked").each(function(el){
				$(this).removeClass('checked');
			});
			$('.brand_select').html(brandSelectArr);
			$('.brand #brand_button').removeClass('multi_brand');
			$('#brand_button').html('Brand <span class="custom-select-clear" aria-label="clear field"></span>');
			getNewsroomFeed();
		});
		
		$(".custom-select [role=option]").on("click", function (e) {
			var value = $(this).attr('data-value');
			if ($(this).parents('.brand').length && value != brand) {
				var brandArr = "";
				var brandSelectArr = "";
				var count = 0;
				var checkVal = $(this).children('.location-checkbox');
				if(checkVal.hasClass('checked')) {
					checkVal.removeClass('checked');
				} else {
					checkVal.addClass('checked');
				}
				if($(this).attr('data-value') == 'Any') {
					$(".brand .multi_brand .custom-select-clear").trigger("click");
					$(".brand .custom-select-list").addClass('hidden');
					return false;
				}

				$(".brand #brand_opt_list .location-checkbox.checked").each(function(el){
					var brandValue = $(this).parent('li').attr('data-value');
					var brandName = $(this).parent('li').text();
					$(this).html("<img src='/themes/custom/universal/src/img/icons/Check_Icon_White.svg' >");
					brandArr+='&brand[' + count + ']='+brandValue;
					brandSelectArr+='<span class="group brand_nbcent">'+brandName+'</span>';
					count++;
				});
				if(count>0) {
					setTimeout(function() {
						$('.brand_select').html("<span>Showing brands results for : </span>"+brandSelectArr);
						$('.brand #brand_button').html('Multiple <span class="custom-select-clear" aria-label="clear field"></span>');
						$('.brand #brand_button').addClass('multi_brand');
					}, 100);
					brand = brandArr;
					multi_brand = true;
				} else {
					$('.brand_select').html(brandSelectArr);
					$('.brand #brand_button').removeClass('multi_brand');
					$('#brand_button').html('Brand <span class="custom-select-clear" aria-label="clear field"></span>');
					brand = 'All';
					multi_brand = false;
				}
				getNewsroomFeed();
			}


			if ($(this).parents('.news-type').length && value != news_type) {
				if (value == 'peacock') {
					brand_peacock = 79;
					news_type = 'All';
				} else {
					news_type = value;
					brand_peacock = 'All';
				}				
			}
			if ($(this).parents('.year').length && value != year) {
				year = value;
			}
			if ($(this).parents('.month').length && value != month) {
				month = value;
			}
			page = 0;
			getNewsroomFeed();
		});
		
		$(".custom-select-button .custom-select-clear").on('click', function() {
			var filter_item = $(this).parents('.custom-select').find('.custom-select-list').attr('aria-activedescendant');
			if(filter_item.indexOf("_0") < 0) {
				
				if ($(this).parents('.news-type').length) {
					news_type = 'All';
					brand_peacock = 'All';
						
				}
				if ($(this).parents('.year').length) {
					year = '';
				}
				if ($(this).parents('.month').length) {
					month = '';
				}
				page = 0;
				getNewsroomFeed();
			}
		});
	}

	function getNewsroomFeed() {
		if(multi_brand) {
			var filters = "&page="+page+"&type="+news_type+brand+"&year="+year+"&month="+month+"&keyword="+keyword+"&brand_peacock="+brand_peacock;
		} else {
			var filters = "&page="+page+"&type="+news_type+"&brand="+brand+"&year="+year+"&month="+month+"&keyword="+keyword+"&brand_peacock="+brand_peacock;
		}
		var $elem = dom.navContent;
		has_newsrooms = true;
		if (!page) {
			$('.newsroom .ajax-filter-icon').show();
			$('.newsroom .content').addClass('overlay_filter');
		}
		$.ajax({
			url: '/api/newsroom/list?_format=json'+filters,
			success: function(ajaxdata) {
				var data2 = ajaxdata.rows;
				if (!page && data2.length) {
					trace.push("set id = "+data2[0].nid);
					//dom.active.html(ajaxdata.first_node);
					dom.active.empty().append(ajaxdata.first_node);					
					dom.imgs = dom.active.find('.article-img, .img, .vid');
					dom.imgs.each(function(){
						trace.push($(this).attr('data-img'));
						var img = $(this).attr('data-img');
						var alt = $(this).attr('data-alt');
						$(this).html('<img src="'+img+'" alt="'+alt+'"/>');
					});

					//data[next].obj.addClass('active');
					dom.active.addClass('active');
					dom.active.removeClass('newsroom_hide');
					dom.nav.removeClass('newsroom_hide');
					$('.newsroom_not_found').remove();
				}
				else if (!page && !data2.length) {
					dom.active.html("");
					dom.active.addClass('newsroom_hide');
					dom.nav.addClass('newsroom_hide');
					$('.newsroom_not_found').remove();
					dom.active.after("<div class=\"newsroom_not_found\"><div class=\"heading\">No Results</div><div class=\"text\">Please use the filters to search for addtional content.</div></div>");
				}
				if (site.getBreakPoint() == 'bp-large' && page) {
					$elem.find('.ajax-read-more').hide();
					$elem.removeClass('overlay');
				}
				if (!data2.length || data2.length !=10) {
					has_newsrooms = false;
				}
				var append = '';
				for (var i = 0, len = data2.length; i < len; ++i) {
					 var newsroom = data2[i];
					 var newsroom_class = 'newsroom-btn';
					 /*if (i == 0) {
						 newsroom_class += ' active';
					 }*/
					 
					   if (newsroom.title.length > 10) {
						  var newsroom_title = newsroom.title.substring(0,10);
					   } else {
						  var newsroom_title = newsroom.title;
					   }
					 append += "<button type=\"button\" class='"+newsroom_class+"'><div class=\"date\">"+newsroom.field_date+"</div><div class=\"type\">"+newsroom.type+"s</div><div class=\"title\">"+newsroom.title.toUpperCase()+"</div><input value=\""+newsroom.nid+"\" class=\"nid\" type=\"hidden\"></button>";
				}
				if (page) {
					append = encodeURIComponent(append);
					$elem.find('.ajax-read-more').before(decodeURIComponent(append)).text();
				}
				else {
					$('.newsroom .ajax-filter-icon').hide();
					$('.newsroom .content').removeClass('overlay_filter');
					append +="<button type=\"button\" class=\"ajax-read-more\"><img src=\"/themes/custom/universal/images/ajax-preloader.gif\"></button>";
					append = encodeURIComponent(append);
					$elem.html('').append(decodeURIComponent(append)).text();
				}
				//console.log($('.newsroom-nav-content').find('button.active').length);
				//console.log($('.newsroom-nav-content').find('button').length);
				if($('.newsroom-nav-content').find('button.active').length == 0) {
					$(".newsroom-nav-content button:first-child").addClass('active')
					//console.log("test");
				}
				//console.log($('.newsroom-nav-content').find('button.active').length);
				$('.newsroom-nav-content').scrollLeft(0);
				$('.newsroom-nav-content').scrollTop(0);
			}
		});
		
		/// Omniture search tracking
		/*if (keyword.trim() != "") {
			s.prop3 = keyword.toLowerCase();
			var s_code = s.t();if(s_code) document.write(s_code);
		}*/
		
		
		
	}
	function set(nid) {
		trace.push("set id = "+nid);
		//next = id;
		dom.active.removeClass('active');
		//data[current].obj.removeClass('active');
		open(nid);
	}
	
	function loadFirstNewsroom(nid){
		trace.push("set id = "+nid);
		dom.imgs = dom.active.find('.article-img, .img, .vid');
		dom.imgs.each(function(){
			trace.push($(this).attr('data-img'));
			var img = $(this).attr('data-img');
			var alt = $(this).attr('data-alt');
			$(this).html('<img src="'+img+'" alt="'+alt+'"/>');
		});

		//data[next].obj.addClass('active');
		dom.active.addClass('active');
	}
	function open(nid) {

		//var previous = dom.active.find('.article');
		//previous.appendTo(data[current].obj);
		$.ajax({
			url: '/api/newsroom/node/'+nid,
			success: function(data2) {
				//dom.active.html(data2.data);
				dom.active.empty().append(data2.data);
				dom.imgs = dom.active.find('.article-img, .img, .vid');
				dom.imgs.each(function(){
					trace.push($(this).attr('data-img'));
					var img = $(this).attr('data-img');
					var alt = $(this).attr('data-alt');
					$(this).html('<img src="'+img+'" alt="'+alt+'"/>');
				});

				//data[next].obj.addClass('active');
				dom.active.addClass('active');
				$('html, body').animate({
				  scrollTop: $(".newsroom-active").offset().top
				}, 1000)

				//current = next;
			}
		});
		
	}
    
    /**
     * @public
     * @function site.newsroom.scrolling
     * @description Handle newsroom scrolling
	 * @example
	 * {@lang JavaScript}
	 * $(window).on('scroll',function() {
 	 *    scrolling();
	 *    site.history.scrolling();
	 *    site.newsroom.scrolling();
	 * });
     */
	function scrolling() {

		if(site.checkMobile() || data.length == 0){
			dom.navContent.css({'height':'auto'});
			return;
		}
		var footPadding = 20;
		var winTop = Math.floor($(window).scrollTop());
		var winHeight = Math.floor($(window).outerHeight());
		var navT = Math.floor(dom.nav.offset().top);
		var footerT = Math.floor(dom.footer.offset().top);
		var distance = navT - winTop;
		var footerOffset = footerT - winHeight - winTop - footPadding;
		if(footerOffset > 0) footerOffset = 0;
		trace.push('[newsroom.js] winH: ' + winHeight);
		trace.push('[newsroom.js] footerOffset: ' + footerOffset);
		var navH = winHeight + footerOffset;
		trace.push('[newsroom.js] navH: ' + navH);
		//if(navH > 0 ) navH = 0;

		trace.push('winTop = '+winTop+" navT = "+navT+" winHeight = "+winHeight+" footerT = "+footerT+" navH = "+navH);
		if(distance <= 0) {
			dom.navHolder.addClass('active');	
		} else {
			dom.navHolder.removeClass('active');	
		}
		dom.navContent.css({'height':navH});
	}
	
	function openMenu() {
		trace.push("openMenu");


		var opened = dom.nav.hasClass('open');	
		if(opened) {
			dom.nav.removeClass('open');
			dom.active.removeClass('open');	
			dom.navMenu.find('.hamburger').addClass('open');
			dom.navMenu.find('.arrow').removeClass('open');
		} else {
			dom.nav.addClass('open');
			dom.active.addClass('open');
			dom.navMenu.find('.hamburger').removeClass('open');
			dom.navMenu.find('.arrow').addClass('open');
		}
	}

	// Public API definitions
	site.newsroom = {
		scrolling:scrolling
	};


	$(function(){
		init();
	});
})(window.site=window.site || {}, jQuery);